import {FileNameData} from '../FileNameData';

export class EmployeeAddRequest {
    name: string;
    surname: string;
    workStartDate: string;
    tck: any;
    tel: string;
    email: string;
    jobTitleId: number;
    parentDepartmentId: number;
    departmentId: number;
    managerId: number;
    approvalManagerId?: number;
    profilePhoto?: FileNameData;
    birthDate: string;
    gender: string;
    endDate: string;
    personalNo: string;
    mealCardNo: string;
}
